import { render, staticRenderFns } from "./DepartmentManagementModal.vue?vue&type=template&id=57274408"
import script from "./DepartmentManagementModal.vue?vue&type=script&lang=js"
export * from "./DepartmentManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports